
const appConfig = {
  API_URL: "https://api.mo2.masorden.com/",
  ADMIN_API_URL: "https://admin.mo2.masorden.com/",
  APP_VERSION: "MAIN-125aa",
};

export default appConfig;
